import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import Avatar from "material-ui/Avatar";
import {
  ListItem,
  ListItemSecondaryAction,
  ListItemText
} from "material-ui/List";
import CreditCardIcon from "material-ui-icons/CreditCard";
import MonetizationOnIcon from "material-ui-icons/MonetizationOn";
import { red, orange, lightGreen, grey, blue } from "material-ui/colors";
import { withRouter } from "react-router-dom";
import moment from "moment";

const styles = theme => ({
  secondary: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginRight: 16
  },
  mainContainer: {
    marginLeft: 24,
    marginRight: 200
  },
  avatar: {
    width: 16,
    height: 16,
    flexShrink: 0,
    marginTop: 6,
    marginBottom: 8,
    marginLeft: 48
  },
  pending: {
    backgroundColor: orange["500"]
  },
  review: {
    backgroundColor: blue["500"]
  },
  active: {
    backgroundColor: lightGreen["A700"]
  },
  suspended: {
    backgroundColor: red["500"]
  },
  closed: {
    backgroundColor: grey["500"]
  },
  icon: {
    color: grey[500],
    marginLeft: 40,
    marginBottom: 2,
    width: 18,
    height: 18
  }
});

const AccountListItem = props => {
  const { history, account, classes } = props;

  const navigateToAccount = () => {
    history.push(`/accounts/${account.id}`);
  };

  const renderPaymentMethodIcon = () => {
    return account.paymentMethod === "none" ? (
      <MonetizationOnIcon className={classes.icon} />
    ) : (
      <CreditCardIcon className={classes.icon} />
    );
  };

  const renderOwners = () => {
    let result = "";
    const maxDisplay = 6;
    if (account.owners) {
      result = account.owners
        .slice(0, maxDisplay + 1)
        .map(o => o.email)
        .join(", ");
      if (account.owners.length > maxDisplay) {
        result += "...";
      }
    }
    return result;
  };

  return (
    <ListItem button divider onClick={navigateToAccount}>
      <ListItemText
        className={classes.mainContainer}
        primary={<div> {account.name} </div>}
        secondary={renderOwners()}
      />
      <ListItemSecondaryAction>
        <div className={classes.secondary}>
          <Typography type="caption" align="right">
            {moment.utc(account.timeCreated).format("Do MMM YY")}
          </Typography>
          <Avatar className={`${classes[account.state]} ${classes.avatar}`} />
          {renderPaymentMethodIcon()}
        </div>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

AccountListItem.propTypes = {
  classes: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired
};

export { AccountListItem };

export default withStyles(styles, { name: "AccountListItem" })(
  withRouter(AccountListItem)
);



// WEBPACK FOOTER //
// ./src/AccountListItem.js